<div
  class="bottom-container-wrapper"
  [@bottomContainerWraper]="this.bottomContainerService.status$.value"
  [class.visible]="bottomContainerService.visible$ | async"
  [class.relative]="bottomContainerService.relativePos$ | async"
>
  <compass-pois-comparator></compass-pois-comparator>
  <compass-local-knowledge-loader *ngIf="!poisComparatorService.selected$.value.length && bottomContainerService.visible$.value"></compass-local-knowledge-loader>
</div>
